import { parseJSON } from '@/components/helpers/utils'
import { SearchspringCollectionProvider } from 'libs/searchspring/fetchers/collection'
import { SearchspringRecommendProvider } from 'libs/searchspring/fetchers/recommend'
import { BeaconAnalyticsProvider } from 'libs/searchspring/hooks/useBeaconAnalytics'
import { useRecommendationCardOptions } from 'libs/searchspring/hooks/useRecommendationCardOptions'

// Parse options helper
const parseOptions = (options) => {
  const parsedOptions = parseJSON(options)

  if (parsedOptions?.groupCells !== undefined) {
    const value = parsedOptions.groupCells

    if (value === 'true') {
      parsedOptions.groupCells = true
    } else if (value === 'false') {
      parsedOptions.groupCells = false
    } else if (!isNaN(value) && typeof value === 'string') {
      parsedOptions.groupCells = Number(value)
    }
  }

  return parsedOptions
}

// Individual provider components
export const RecommendationWrapper = ({ children, profile, productId, limit }) => (
  <SearchspringRecommendProvider profile={profile} productId={productId} limit={limit}>
    <BeaconAnalyticsProvider profile={profile}>
      {children}
    </BeaconAnalyticsProvider>
  </SearchspringRecommendProvider>
)

export const CollectionWrapper = ({ children, handle, limit }) => (
  <SearchspringCollectionProvider handle={handle} resultsPerPage={limit}>
    {children}
  </SearchspringCollectionProvider>
)

// Main component that uses the appropriate provider
export const ProductRecommendation = ({
  providerType = 'recommend',
  profile,
  handle,
  productId,
  itemClass,
  carouselOptions = {},
  productCardOptions,
  limit,
  component: Component
}) => {
  const parsedOptions = parseOptions(carouselOptions)
  const { cardOptions, backgroundColour } = useRecommendationCardOptions(productCardOptions)

  const renderedComponent = (
    <Component
      className={itemClass}
      options={parsedOptions}
      {...cardOptions}
      wrapperClassName={backgroundColour}
    />
  )

  if (providerType === 'collection') {
    return <CollectionWrapper handle={handle} limit={limit}>{renderedComponent}</CollectionWrapper>
  }

  if (providerType === 'recommend') {
    return (
      <RecommendationWrapper
        profile={profile}
        productId={productId}
        limit={limit}
      >
        {renderedComponent}
      </RecommendationWrapper>
    )
  }

  console.error(`Unknown provider type: ${providerType}`)
  return <div>Invalid provider type: {providerType}</div>
}

// For backward compatibility, you can also export a HOC version
export function withRecommendationProvider(Component, providerType = 'recommend') {
  return function WrappedComponent(props) {
    return <ProductRecommendation {...props} providerType={providerType} component={Component} />
  }
}
